import { define, type, auto } from 'type-r'
import { store } from '../models/store.js'
import View from './view.js'

@define
export default class CalendarComponent extends View {
    get date() {
        return store.date;
    }

    get visible() {
        return $(this.el).is(":visible")
    }
    
    show() {
        $(this.el).show();
        const yy = this.date.getFullYear();
        $.ajax({
            url: '/getcal?month=' + (this.date.getMonth() + 1) + '&year=' + yy,
            success: (data) => $(this.el).html(data)
        });        
    }

    hide() {
        $(this.el).hide();
    }
    
    goMonth(inc: number): void {
        this.date.setMonth(this.date.getMonth() + inc);
        this.show();
    }
    
}
